import {
	SAVE_STORECODE,
        GET_STORECODE,
        SAVE_MEMBERCODE,
        GET_MEMBERCODE,
        SAVE_OPENID,
        GET_OPENID,
        SAVE_EMPLOYEECODE,
        GET_EMPLOYEECODE,
        SAVE_POSITION,
        GET_POSITION,
        SAVE_TOKEN,
        GET_TOKEN,
        SAVE_USERNAME,
        SAVE_USERFROMTYPE,
        SET_BOOKINGNUM,
        SET_COMMENNUM,
        SAVE_NICKNAME,
        SAVE_MOBILE,
        GET_NICKNAME,
        GET_MOBILE,
        SAVE_UNIONID,
        GET_UNIONID,
} from './mutation-types.js'

import {setStore, getStore} from '../config/mUtils'



export default {
    [SET_COMMENNUM](state, info) {
                state.commennum = info;
    },
    [SET_BOOKINGNUM](state, info) {
                state.bookingnum = info;
    },
    [SAVE_NICKNAME](state, nickname) {
            if(nickname){
                state.nickname = nickname;
                setStore('nickname', nickname);
            }else{
                 state.nickname = '';
            }
    },
    [SAVE_MOBILE](state, mobile) {
            if(mobile){
                state.mobile = mobile;
                setStore('mobile', mobile);
            }else{
                 state.mobile = '';
            }
    },
    [GET_NICKNAME](state) {

            let nickname = getStore('nickname');
            if (nickname) {
               state.nickname = nickname;
            }
    },
    [GET_MOBILE](state) {
            let mobile = getStore('mobile');
            if (mobile) {
               state.mobile = mobile;
            }
    },
	[SAVE_STORECODE](state, storeCode) {
            if(storeCode){
                state.storeCode = storeCode;
                setStore('storeCode', storeCode);
            }else{
                 state.storeCode = '';
            }
	},
        [GET_STORECODE](state) {
	    let storeCode = getStore('storeCode');
            if (storeCode) {
               state.storeCode = storeCode;
            }
	},
        [SAVE_MEMBERCODE](state, memberCode) {
            if(memberCode){
                state.memberCode = memberCode;
                setStore('memberCode', memberCode);
            }else{
                 state.memberCode = '';
            }
	},
        [GET_MEMBERCODE](state) {
	    let memberCode = getStore('memberCode');
            if (memberCode) {
               state.memberCode = memberCode;
            }
	},
        [SAVE_OPENID](state, openId) {
            if(openId){
                state.openId = openId;
                setStore('openId', openId);
            }else{
                state.openId = '';
            }
	},
        [GET_OPENID](state) {
	    let openId = getStore('openId');
            if (openId) {
               state.openId = openId;
            }
	},
        [SAVE_EMPLOYEECODE](state, employeeCode) {
            if(employeeCode){
                state.employeeCode = employeeCode;
                setStore('employeeCode', employeeCode);
            }else{
                state.employeeCode = '';
            }
	},
        [GET_EMPLOYEECODE](state) {
	    let employeeCode = getStore('employeeCode');
            if (employeeCode) {
               state.employeeCode = employeeCode;
            }
	},
        [SAVE_POSITION](state, position) {
            if(position){
                state.position = position;
                setStore('position', position);
            }else{
                state.position = '';
            }
	},
        [GET_POSITION](state) {
	    let position = getStore('position');
            if (position) {
               state.position = position;
            }
	},
	 [SAVE_TOKEN](state, token) {
            if(token){
                state.token = token;
                setStore('token', token);
            }else{
                state.token = '';
            }
	},
  [GET_TOKEN](state) {
    let token = getStore('token');
    if (token) {
      state.token = token;
    }
  },
         [SAVE_USERNAME](state, userName) {
            if(userName){
                state.userName = userName;
                setStore('userName', userName);
            }else{
                state.userName = '';
            }
	},
        [SAVE_USERFROMTYPE](state, userFromType) {
            if(userFromType){
                state.userFromType = userFromType;
                setStore('userFromType', userFromType);
            }else{
                state.userFromType = '';
            }
	},
    [SAVE_UNIONID](state, unionId) {
        if(unionId){
            state.unionId = unionId;
            setStore('unionId', unionId);
        }else{
            state.unionId = '';
        }
    },
    [GET_UNIONID](state) {
        let unionId = getStore('unionId');
        if (unionId) {
            state.unionId = unionId;
        }
    },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js